import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import cx from 'classnames';
import { api, staticpageUploadDir } from '../../config';

class CommonModal extends Component {

    static propTypes = {
        children: PropTypes.node.isRequired,
        modalStatus: PropTypes.bool.isRequired,
        modalType: PropTypes.string,
        title: PropTypes.string,
        onHide: PropTypes.func.isRequired,
    };

    render() {
        const { modalStatus, title, onHide, dialogClassName, modalHeader, modalBody, noCloseIcon, titleHidden, isBookingBanner, safetyMeasuresImage } = this.props;
        return (
            <Modal
                show={modalStatus}
                animation={false}
                onHide={onHide}
                dialogClassName={cx(dialogClassName, 'commonModalContainer')}
            >
                <Modal.Header closeButton={!noCloseIcon ? true : false} className={cx(modalHeader, 'commonModalHeader')}>
                    <Modal.Title>
                        <div className={cx("commonModalTitle", { ['commonModalHeaderLogoContainer']: isBookingBanner })}>
                            {isBookingBanner && safetyMeasuresImage ? (
                                <>
                                    <div className={'commonModalHeaderLogo'}>
                                        <img src={api.apiEndpoint + staticpageUploadDir + safetyMeasuresImage} alt="Safety Measure" />
                                    </div>
                                    {title}
                                </>
                            ) : (
                                <span className={cx(titleHidden ? "visibleHidden" : "")}>{title}</span>
                            )}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={cx(modalBody, 'commonModalBody')}>
                    <div>
                        {this.props.children}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapState = state => ({
    noCloseIcon: state?.adminModalStatus?.formData?.noCloseIcon
});


const mapDispatch = {
};

export default connect(mapState, mapDispatch)(CommonModal);  